import useFetch from './useFetch';
import { FetchApiInterface } from '../interfaces/FetchApi.interface';
import { APP_VERSION } from '../config/config';

export interface LoginResult {
  requiresOtp: boolean;
  otpConfigured: boolean;
}

export interface OtpSetupResult {
  qrCodeUrl: string;
  secret: string;
  otpAlreadyConfigured: boolean;
}

export interface OtpLoginResult {
  token: string;
  refreshToken: string;
  data: any;
  roles: string[];
}

const DEV_UUID_KEY = 'dev_uuid';

const getDevUuid = (): string => {
  let uuid = localStorage.getItem(DEV_UUID_KEY);
  if (!uuid) {
    uuid = crypto.randomUUID();
    localStorage.setItem(DEV_UUID_KEY, uuid);
  }
  return uuid;
};

function useOtp() {
  const { fetchApi, loading } = useFetch();

  const loginUser = async (username: string, password: string): Promise<LoginResult> => {
    const request: FetchApiInterface = {
      url: '/auth/login_with_otp_validation',
      method: 'POST',
      data: {
        username,
        password,
        devUuid: getDevUuid(),
        appVersion: APP_VERSION,
      },
    };
    const { data } = await fetchApi(request);
    return data.data as LoginResult;
  };

  const setupOtp = async (username: string, password: string): Promise<OtpSetupResult> => {
    const request: FetchApiInterface = {
      url: '/auth/otp/setup',
      method: 'POST',
      data: { username, password },
    };
    const { data } = await fetchApi(request);
    return data.data as OtpSetupResult;
  };

  const verifySetup = async (username: string, otpCode: string): Promise<boolean> => {
    const request: FetchApiInterface = {
      url: '/auth/otp/verify-setup',
      method: 'POST',
      data: { username, otpCode },
    };
    const { data } = await fetchApi(request);
    return data.data as boolean;
  };

  const loginWithOtp = async (
    username: string,
    password: string,
    otpCode: string
  ): Promise<OtpLoginResult> => {
    const request: FetchApiInterface = {
      url: '/auth/login_otp',
      method: 'POST',
      data: { username, password, otpCode },
    };
    const { data } = await fetchApi(request);
    return data.data as OtpLoginResult;
  };

  return { loginUser, setupOtp, verifySetup, loginWithOtp, loading };
}

export default useOtp;
